export const updateDesignBgColor = (component, bgColor) => {
  var _design$background, _design$background2;
  const {
    design
  } = component;
  if (!isContainerDesignData(design)) {
    throw new Error('Design is not a container background ref');
  }
  if (((_design$background = design.background) == null || (_design$background = _design$background.colorLayers) == null ? void 0 : _design$background[0].fill.type) === 'SolidColor') {
    design.background.colorLayers[0].fill.color = bgColor;
  } else if ((_design$background2 = design.background) != null && _design$background2.color) {
    design.background.color = bgColor;
  }
  return {
    ...component,
    design
  };
};
export const isContainerDesignData = design => Boolean(design && design.background);
//# sourceMappingURL=update-design-bg-color.js.map